// exclui os atributos do objeto que são nulos/vazios/undefined
function emptyObject(obj) {
  return Object.keys(obj)
    .filter((key) => obj[key])
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

// atribui string vazia para todos os atributos do objeto
const clearObject = (object, isObject = false) => {
  const obj = isObject ? object : JSON.parse(object);
  const objLimpos = Object.keys(obj).reduce((accumulator, currentValue) => {
    accumulator[currentValue] = '';
    return accumulator;
  }, {});
  return objLimpos;
};

// formata a string para que fique com a primeira letra maiuscula
const capitalize = (str) => {
  if (typeof str !== 'string') {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.substr(1);
};

const formattedDateTime = (dateTime) => {
  if (!dateTime) return '';
  const dataRetornada = dateTime;
  const dataCortada = dataRetornada.split('-');
  const horaCortada = dataCortada[2].split(' ');
  return `${dataCortada[0]}/${dataCortada[1]}/${horaCortada[0]} às ${horaCortada[1]} `;
};

const formattedDateTimeIso = (dateTime) => {
  if (!dateTime) return null;
  const dataRetornada = dateTime;
  const dataCortada = dataRetornada.split('-');
  const horaCortada = dataCortada[2].split(' ');
  return new Date(
    `${horaCortada[0]}-${dataCortada[1]}-${dataCortada[0]}T${horaCortada[1]}`,
  );
};

const goToReferenceId = (referenceTable, referenceId) => {
  const allReferenceTable = {
    1: '',
    2: 'vendas/pagamentos',
    3: 'vendas/pesquisar',
    4: 'produto/pesquisar',
    5: 'gestao/custos',
    6: 'gestao/contas',
    8: 'gestao/ajustes',
  };
  const local = allReferenceTable[referenceTable];
  const link = `/home/${local}/${referenceId}`;
  return link || '#';
};

const allNotificationTypes = {
  1: 'caixas/sangria',
  2: 'gestao/contas',
};

const goToNotificationsTable = (referenceTable, referenceId) => {
  const local = allNotificationTypes[referenceTable];
  const link = `/home/${local}/${referenceId}`;
  return link || '#';
};

const allReferenceTable = [
  { id: 1, name: 'Transferência' },
  { id: 2, name: 'Pagamento' },
  { id: 3, name: 'Venda' },
  { id: 4, name: 'Saida' },
  { id: 5, name: 'Gasto' },
  { id: 6, name: 'Conta/ custo' },
  { id: 7, name: 'Serviço' },
  { id: 8, name: 'Ajuste Administrativo' },
];

allReferenceTable.sort((a, b) => a.name.localeCompare(b.name));

const listReferenceTable = (referenceId) => {
  const reference = allReferenceTable.find(
    (value) => value.id === Number(referenceId),
  );
  return reference.name;
};

const formattedCurrency = (money) =>
  Number(money).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const maskedCurrency = (value) => {
  const strValue = String(value || 0).replace(/\D/g, '');
  const formattedValue = (Number(strValue) / 100).toFixed(2);

  return formattedValue.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

const isEqualObject = (objA = [], objB = []) => {
  const parseObjA = JSON.stringify(objA);
  const parseObjB = JSON.stringify(objB);
  return parseObjA === parseObjB;
};

const calculateMarkupByValue = (cost, value) => {
  const numCost = Number(cost || 0);
  const numValue = Number(value || 0);
  if (!numCost || !numValue || isNaN(numCost) || isNaN(numValue)) return '0.00';
  const result = ((numValue / numCost) * 100 - 100);
  return isFinite(result) ? result.toFixed(2) : '0.00';
};

const calculateMarginByValue = (cost, value) => {
  const numCost = Number(cost || 0);
  const numValue = Number(value || 0);
  if (!numValue || isNaN(numCost) || isNaN(numValue)) return '0.00';
  const result = (((numValue - numCost) / numValue) * 100);
  return isFinite(result) ? result.toFixed(2) : '0.00';
};

const calculateProfitByValue = (cost, value) => {
  const numericCost = Number(cost || 0);
  const numericValue = Number(value || 0);
  if (isNaN(numericCost) || isNaN(numericValue)) return '0.00';
  const result = numericValue - numericCost;
  return isFinite(result) ? result.toFixed(2) : '0.00';
};

const calculateValueByMargin = (cost, margin) => {
  const numCost = Number(cost || 0);
  const numMargin = Number(margin || 0);
  if (isNaN(numCost) || isNaN(numMargin) || numMargin >= 100) return '0.00';
  const result = numCost / (1 - numMargin / 100);
  return isFinite(result) ? result.toFixed(2) : '0.00';
};

const calculateValueByMarkup = (cost, markup) => {
  const numCost = Number(cost || 0);
  const numMarkup = Number(markup || 0);
  if (isNaN(numCost) || isNaN(numMarkup)) return '0.00';
  const result = numCost * (1 + numMarkup / 100);
  return isFinite(result) ? result.toFixed(2) : '0.00';
};

const formatCPF = (input) => {
  // garante string e remove tudo que não for dígito
  if (!input) return null
  const digits = String(input ?? '').replace(/\D/g, '').slice(0, 11);
  if (digits.length === 0) return '';

  const p1 = digits.slice(0, 3);
  const p2 = digits.slice(3, 6);
  const p3 = digits.slice(6, 9);
  const p4 = digits.slice(9, 11);

  let formatted = p1;
  if (p2) formatted += '.' + p2;
  if (p3) formatted += '.' + p3;
  if (p4) formatted += '-' + p4;

  return formatted;
}

const formatClient = (clientId, clientInfo) => {
  const client = clientInfo?.data?.find((value) => value.id == clientId);
  const fullName = `${client?.name || 'Avulso'} ${client?.lastName || ''}`;
  return fullName;
}

const parseImages = (imgs) => {
  if (!imgs) return [];
  if (Array.isArray(imgs)) return imgs;
  if (typeof imgs === 'string') {
    try {
      return JSON.parse(imgs);
    } catch (e) {
      return [];
    }
  }
  return [];
};

const normalizeText = (text) => {
  if (!text) return '';
  return String(text)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

const parseFractionOrNumber = (val) => {
  if (typeof val === 'number') return val;
  if (!val) return 0;
  const str = String(val).trim().replace(',', '.');
  if (str.includes('/')) {
    const parts = str.split('/');
    if (parts.length === 2) {
      const num = parseFloat(parts[0]);
      const den = parseFloat(parts[1]);
      if (!isNaN(num) && !isNaN(den) && den !== 0) {
        return parseFloat((num / den).toFixed(4));
      }
    }
  }
  const parsed = parseFloat(str);
  return isNaN(parsed) ? 0 : parsed;
};

const formatStockAmount = (val) => {
  if (val === null || val === undefined || val === '') return '0';
  const num = typeof val === 'number' ? val : Number(String(val).replace(',', '.'));
  if (isNaN(num)) return String(val);
  if (Number.isInteger(num)) {
    return String(num);
  }
  return num.toLocaleString('pt-BR', { maximumFractionDigits: 4 });
};

const safeParseParticulars = (val) => {
  if (!val) return {};
  if (typeof val === 'object') return val;
  if (typeof val === 'string') {
    const trimmed = val.trim();
    if (!trimmed || trimmed === '{}') return {};
    try {
      return JSON.parse(trimmed);
    } catch (e) {
      try {
        return JSON.parse(trimmed.replace(/'/g, '"'));
      } catch (e2) {
        return {};
      }
    }
  }
  return {};
};

export {
  calculateMarkupByValue,
  calculateMarginByValue,
  calculateProfitByValue,
  calculateValueByMargin,
  calculateValueByMarkup,
  emptyObject,
  capitalize,
  clearObject,
  formattedDateTime,
  formattedCurrency,
  formattedDateTimeIso,
  goToReferenceId,
  goToNotificationsTable,
  listReferenceTable,
  allReferenceTable,
  isEqualObject,
  maskedCurrency,
  formatCPF,
  formatClient,
  parseImages,
  normalizeText,
  parseFractionOrNumber,
  formatStockAmount,
  safeParseParticulars,
};

